import Cookies from "js-cookie"
import { html } from "lit-html"
import { virtual, useEffect, useState } from "haunted"
import { SelectBox } from "../utils/select-box"
import { FILTER_BY_DATE_OPTIONS } from "./constants"

export const KeyStatsComponent = virtual(({ endpoint }) => {
  const [loading, setLoading] = useState(true)
  const [assignmentsCount, setAssignmentsCount] = useState(0)
  const [
    acceptedApplicationsPercent,
    setAcceptedApplicationsPercent,
  ] = useState(null)
  const [stats, setStats] = useState({})
  const [queryStr, setQueryStr] = useState("")
  const csrftoken = Cookies.get("csrftoken")

  const loadUserKeyStats = () => {
    if (queryStr in stats) {
      setAssignmentsCount(stats[queryStr].assignmentsCount)
      setAcceptedApplicationsPercent(stats[queryStr].acceptanceRate)
      return
    }

    setLoading(true)
    fetch(`${endpoint}?${queryStr}`, {
      method: "GET",
      credentials: "include",
      headers: {
        "X-CSRFToken": csrftoken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const {
          assignments_count: assignmentsCount,
          acceptance_rate: acceptanceRate,
        } = res
        const roundedAcceptanceRate =
          acceptanceRate !== null
            ? Math.round(acceptanceRate * 100).toString()
            : null

        setStats({
          [queryStr]: {
            assignmentsCount,
            acceptanceRate: roundedAcceptanceRate,
          },
          ...stats,
        })
        setAssignmentsCount(assignmentsCount)
        setAcceptedApplicationsPercent(roundedAcceptanceRate)
        setLoading(false)
      })
      .catch((err) => console.error(err))
  }

  useEffect(loadUserKeyStats, [queryStr])

  const $profileImgSrc = document.querySelector("#profile-img-src")
  const iconAssignmentSrc = $profileImgSrc.dataset.iconAssignment
  const iconApplicationSrc = $profileImgSrc.dataset.iconApplication

  const content = html`
    <div class="mt-8 flex flex-row flex-wrap">
      <div class="w-full flex flex-row sm:w-1/2">
        <div
          class="stats-icon bg-yellow mr-8 flex flex-col justify-center items-center"
        >
          <img class="stats-img" src="${iconAssignmentSrc}" alt="Assignment" />
        </div>
        <p class="flex flex-col justify-between">
          <span class="stats-value text-40 font-bold">${assignmentsCount}</span>
          <span class="text-gray-600"
            >Assignment${assignmentsCount == 1 ? "" : "s"}</span
          >
        </p>
      </div>
      ${acceptedApplicationsPercent
        ? html`
            <div class="w-full mt-10 flex flex-row sm:w-1/2 sm:mt-0">
              <div
                class="stats-icon bg-tag-bg-green mr-8 flex flex-col justify-center items-center"
              >
                <img
                  class="stats-img"
                  src="${iconApplicationSrc}"
                  alt="Application"
                />
              </div>
              <p class="flex flex-col justify-between">
                <span class="stats-value text-40 font-bold"
                  >${acceptedApplicationsPercent}%</span
                >
                <span class="text-gray-600">Accepted applications</span>
              </p>
            </div>
          `
        : html``}
    </div>
  `

  return html`
    <div
      class="section-box px-7 pt-8 pb-11 text-black loader-container ${loading
        ? "loading"
        : ""}"
    >
      <div class="sm:flex flex-row justify-between">
        <h2 class="font-serif text-sm">Key Statistics</h2>
        ${SelectBox({
          width: "175px",
          options: FILTER_BY_DATE_OPTIONS.map(({ label, queryStr }) => ({
            label,
            onClick: () => setQueryStr(queryStr),
          })),
        })}
      </div>
      ${loading ? "" : content}
    </div>
  `
})
